export default __webpack_public_path__ + "static/media/home.d32335fc.png";